import { useEffect, useState } from "react";
export const ScrollTop = () => {
  const [showToTopButton, setShowToTopButton] = useState(false);

  // On scroll event, toggle button visibility based on scroll position
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 500) {
        setShowToTopButton(true);
      } else {
        setShowToTopButton(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // Function to scroll to the top of the page smoothly
  const goToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <>
      {showToTopButton && (
        <button
          id="to-top-button"
          onClick={goToTop}
          title="Go To Top"
          className="z-10 fixed bottom-10 right-10 p-4 border-0 w-14 h-14 rounded-full shadow-md bg-emerald-800 hover:bg-emerald-700 text-white text-lg font-semibold transition-colors duration-300"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            className="w-6 h-6"
          >
            <path d="M12 4l8 8h-6v8h-4v-8H4l8-8z" />
          </svg>
          <span className="sr-only">Go to top</span>
        </button>
      )}
    </>
  );
};
